import { useState, useEffect, useRef } from "react";

export const COLORS = [
  { value: "green",  label: "Green",  bg: "bg-green-500" },
  { value: "blue",   label: "Blue",   bg: "bg-blue-500" },
  { value: "red",    label: "Red",    bg: "bg-red-500" },
  { value: "orange", label: "Orange", bg: "bg-orange-500" },
  { value: "purple", label: "Purple", bg: "bg-purple-500" },
];

export const COLOR_BG = {
  green: "bg-green-500",
  blue: "bg-blue-500",
  red: "bg-red-500",
  orange: "bg-orange-500",
  purple: "bg-purple-500",
};

export function ColorDot({ color, onColorChange, size = "md" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const dot  = size === "lg" ? "w-5 h-5" : size === "sm" ? "w-3 h-3" : "w-4 h-4";
  const btn  = size === "lg" ? "w-6 h-6" : size === "sm" ? "w-4 h-4" : "w-5 h-5";

  return (
    <div className="relative flex-shrink-0" ref={ref}>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
        className={`${btn} rounded-full flex items-center justify-center`}
        title={color ? `Color: ${color}` : "Set color tag"}
      >
        {color ? (
          <span className={`${dot} rounded-full ${COLOR_BG[color]} shadow-sm`} />
        ) : (
          <span className={`${dot} rounded-full border-2 border-dashed border-gray-300 hover:border-gray-400 transition-colors`} />
        )}
      </button>

      {open && (
        <div className="absolute left-0 top-7 z-50 bg-white rounded-2xl border border-gray-200 shadow-xl p-2.5 flex items-center gap-2">
          {/* Clear */}
          <button type="button"
            onClick={(e) => { e.stopPropagation(); onColorChange(null); setOpen(false); }}
            className="w-6 h-6 rounded-full border-2 border-dashed border-gray-300 hover:border-red-400 transition-colors flex-shrink-0"
            title="Remove color"
          />
          {COLORS.map(c => (
            <button key={c.value} type="button"
              onClick={(e) => { e.stopPropagation(); onColorChange(c.value); setOpen(false); }}
              className={`w-6 h-6 rounded-full ${c.bg} flex-shrink-0 transition-transform hover:scale-110 shadow-sm ${color === c.value ? "ring-2 ring-offset-1 ring-gray-500 scale-110" : ""}`}
              title={c.label}
            />
          ))}
        </div>
      )}
    </div>
  );
}
